import { render, staticRenderFns } from "./HpHV2.vue?vue&type=template&id=04bf682f&scoped=true&"
import script from "./HpHV2.vue?vue&type=script&lang=js&"
export * from "./HpHV2.vue?vue&type=script&lang=js&"
import style0 from "./HpHV2.vue?vue&type=style&index=0&id=04bf682f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf682f",
  null
  
)

export default component.exports